// react-redux imports
import { useEffect } from "react";
import { useDispatch, useSelector, useStore } from "react-redux";
import { useHistory } from "react-router";
import { setIsAuthDialogOpen } from "features/authDialog/authDialogSlice";
import { setHeaderWidthMode, setIsMenuOpen } from "features/header/headerSlice";
import { RootState } from "app/store";

import ActionGroup from "./styled-components/ActionGroup";
import Container from "./styled-components/Container";
import OptionsItem from "./styled-components/OptionsItem";
import OptionsList from "./styled-components/OptionsList";
import SignInButton from "./styled-components/SignInButton";

import dotenv from "dotenv";
dotenv.config();

function Menu() {
  const dispatch = useDispatch();
  const history = useHistory();
  const user = useSelector((state: RootState) => state.auth);
  const isUserAuthenticated = !Object.values(user).includes(undefined);
  const {
    header: { widthMode: headerWidthMode },
  } = useStore().getState();

  function handleOptionClick(path: string) {
    return () => {
      if (history.location.pathname !== path) history.push(path);
      if (path === 'nosotros') {
        let url=process.env.REACT_APP_US_URL
        window.open(url)
      }
      if (path === 'contacto') {
        let url=process.env.REACT_APP_CONTACT_URL
        window.open(url)
      }
      else history.replace(path);
      dispatch(setIsMenuOpen(false));
    };
  }

  function handleSignIn() {
    dispatch(setHeaderWidthMode(headerWidthMode));
    dispatch(setIsMenuOpen(false));
    dispatch(setIsAuthDialogOpen(true));
  }

  useEffect(() => {
    dispatch(setHeaderWidthMode("full"));
    return () => {
      if (history.location.pathname === "/factors")
        dispatch(setHeaderWidthMode("half"));
    };
  }, []);

  return (
    <Container>
      {!isUserAuthenticated && (
        <ActionGroup>
          <SignInButton onClick={handleSignIn}>Iniciar sesión</SignInButton>
        </ActionGroup>
      )}
      <OptionsList>
        <OptionsItem onClick={handleOptionClick("calculator")}>
          Calculadora
        </OptionsItem>

        <OptionsItem onClick={handleOptionClick("factors")}>
          Factores
        </OptionsItem>

        <OptionsItem onClick={handleOptionClick("nosotros")}>Nosotros</OptionsItem>

        <OptionsItem onClick={handleOptionClick("contacto")}>Contacto</OptionsItem>
      </OptionsList>
    </Container>
  );
}

export default Menu;
